import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './navbar.css';
import BackArrow from "./BackArrow";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  
  const isHome = location.pathname === "/" || location.pathname === "/home";
  const isActive = (path) => location.pathname === path;

  return (
    <div className="navbar">
    
      {!isHome && <BackArrow />}

    
      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      
      <div className="navbar-left">
        <Link to="/" className={isActive("/") ? "active" : ""}>Home</Link>
        <Link to="/industries" className={isActive("/industries") ? "active" : ""}>Industries</Link>
        <Link to="/services" className={isActive("/services") ? "active" : ""}>Services</Link>
        <Link to="/solutions" className={isActive("/solutions") ? "active" : ""}>Solutions</Link>
      </div>

      <div className="logo-container">
        <Link 
          to="/" 
          onClick={() => {
            setIsOpen(false); 
            window.scrollTo({ top: 0, behavior: "smooth" }); 
          }}
        >
          <img src={logo} alt="Neelaverse Logo" className="center-logo" />
        </Link>
      </div>

      
      <div className="navbar-right">
        <Link to="/skillupgrade" className={isActive("/skillupgrade") ? "active" : ""}>Skill Upgrade</Link>
        <Link to="/about" className={isActive("/about") ? "active" : ""}>About</Link>
        <Link to="/contact" className={isActive("/contact") ? "active" : ""}>Contact Us</Link>
        <Link to="/careers" className={isActive("/careers") ? "active" : ""}>Careers</Link>
      </div>

      
      <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
        <Link to="/industries" onClick={() => setIsOpen(false)}>Industries</Link>
        <Link to="/services" onClick={() => setIsOpen(false)}>Services</Link>
        <Link to="/solutions" onClick={() => setIsOpen(false)}>Solutions</Link>
        <Link to="/skillupgrade" onClick={() => setIsOpen(false)}>Skill Upgrade</Link>
        <Link to="/about" onClick={() => setIsOpen(false)}>About</Link>
        <Link to="/contact" onClick={() => setIsOpen(false)}>Contact Us</Link>
        <Link to="/careers" onClick={() => setIsOpen(false)}>Careers</Link>
      </div>
    </div>
  );
}

export default Navbar;
